/* eslint-disable react-hooks/exhaustive-deps */
import { LessonsList } from './components/LessonsList';
import { useMyLessonHook } from './hooks/useMyLessonHook';

export const LessonsPage = () => {
    const { loading, lessonData } = useMyLessonHook();

    return <LessonsList loading={loading} lessonData={lessonData} />;
};
